<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <g opacity="0.8">
        <path d="M11.4998 15.3337C13.6169 15.3337 15.3332 13.6174 15.3332 11.5003C15.3332 9.38323 13.6169 7.66699 11.4998 7.66699C9.38275 7.66699 7.6665 9.38323 7.6665 11.5003C7.6665 13.6174 9.38275 15.3337 11.4998 15.3337Z" fill="white"/>
        <path d="M12.4582 3.89978V1.91699H10.5415V3.89978C8.85512 4.1151 7.28793 4.88416 6.0858 6.08629C4.88367 7.28842 4.11462 8.85561 3.8993 10.542H1.9165V12.4587H3.8993C4.1143 14.1452 4.88325 15.7125 6.08544 16.9147C7.28763 18.1169 8.855 18.8859 10.5415 19.1009V21.0837H12.4582V19.1009C14.1447 18.886 15.7122 18.1171 16.9144 16.9149C18.1166 15.7127 18.8855 14.1452 19.1004 12.4587H21.0832V10.542H19.1004C18.8854 8.85549 18.1164 7.28812 16.9142 6.08593C15.712 4.88374 14.1447 4.11479 12.4582 3.89978ZM11.4998 17.2503C8.32871 17.2503 5.74984 14.6715 5.74984 11.5003C5.74984 8.3292 8.32871 5.75033 11.4998 5.75033C14.671 5.75033 17.2498 8.3292 17.2498 11.5003C17.2498 14.6715 14.671 17.2503 11.4998 17.2503Z" fill="white"/>
        </g>
        </svg>
</template>

<script>
    export default {
        name: 'location_logo'
    }
</script>

<style lang="scss" scoped>

</style>